import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-methods-step-3" }
const _hoisted_2 = { class: "e-application-wrapper__card-footer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdministrativeFee = _resolveComponent("AdministrativeFee")!
  const _component_CardInput = _resolveComponent("CardInput")!
  const _component_UPN = _resolveComponent("UPN")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_ctx.getTitle)), 1),
      (_ctx.paymentMethod === 'tax-confirmation')
        ? (_openBlock(), _createBlock(_component_AdministrativeFee, {
            key: 0,
            onFileSelected: _ctx.addAttachment
          }, null, 8, ["onFileSelected"]))
        : _createCommentVNode("", true),
      (['credit-card', 'paypal'].includes(_ctx.paymentMethod))
        ? (_openBlock(), _createBlock(_component_CardInput, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.paymentMethod === 'upn')
        ? (_openBlock(), _createBlock(_component_UPN, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        class: "defaultButton",
        disabled: !_ctx.isValid,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('nextPage', _ctx.attachment)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("forms.payment_methods.button_label")), 1),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("div", {
        class: "back-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('prevPage')))
      }, _toDisplayString(_ctx.$t("global.back")), 1),
      _createVNode(_component_router_link, { to: { name: 'NewApplications' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}